"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelHoldCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * The branch that is currently being played is forced until the end of the song.
 */
class LevelHoldCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.LevelHold);
    }
    static parse(_args) {
        return new LevelHoldCommand();
    }
}
exports.LevelHoldCommand = LevelHoldCommand;
